<template>
	<div class="typeList-content">
		<content-list :title="contentTitle" :list="contentList" @refreshList="refreshList"></content-list>
	</div>
</template>

<script>
	import contentList from '../../components/content-list.vue'
	export default{
		components:{
			contentList
		},
	}
</script>

<style>
</style>
